import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./StoryScreen1.css"
import { ImgMobileStoryScreen1, ImgStoryScreen1, ImgStoryScreen1b, ImgStoryScreen1c, ImgStoryScreen1d, NewScreenStoryBackground } from "../../assets";

const StoryScreen1 = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenStoryScreen1 = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenStoryScreen1.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: windowWidthClass==="w-mob"||windowWidthClass==="w-tab"? ImgMobileStoryScreen1 :NewScreenStoryBackground,
                alt: ""
            }
        },
        shield: {

        },
        content: {
            left: {
                title: "LONG STORY SHORT"
            },
            right: {
                desc: "Neocolonialism, in the context of food, refers to a contemporary form of economic and cultural domination by powerful entities, such as multinational corporations, over less powerful regions and their food systems. It involves exploiting resources, knowledge, and traditional foods for profit, often while erasing or appropriating the cultural and historical origins of those foods."
            },
        }
    }
    
    return(
        <>
            <div 
            ref={screenStoryScreen1} 
            className={`${windowWidthClass}-story-screen-1 wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display grid">
                    <div className="text-wrapper left">
                        <h1>{componentData.content.left.title}</h1>
                    </div>
                    <div className="text-wrapper right">
                        {/* <h2>{componentData.content.right.desc}</h2> */}
                    </div>
                    
                </div>

            </div>
        </>
        
    )
};

export default StoryScreen1;